import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatList, MatListItem, MatListItemTitle, MatListItemMeta } from '@angular/material/list';
import { RootState } from '@next/core-lib/app';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { PageToolbarComponent, SummaryCardComponent } from '@next/core-lib/components';
import { LocaleService, TranslatePipe } from '@next/core-lib/i18n';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { ReferenceScheme } from 'src/app/reference-scheme/models/reference-scheme.model';

import { FeedAdvice } from '../../models/feed-advice.models';
import * as feedAdviceActions from '../../store/feed-advice.actions';
import { getReferenceSchemes } from '../../store/feed-advice.selectors';

@Component({
  selector: 'app-create-feed-advice-from-reference',
  templateUrl: './create-feed-advice-from-reference.component.html',
  styleUrls: ['./create-feed-advice-from-reference.component.scss'],
  imports: [
    PageToolbarComponent,
    SummaryCardComponent,
    MatList,
    MatListItem,
    MatListItemTitle,
    MatButton,
    MatListItemMeta,
    MatIcon,
    NgIf,
    NgFor,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class CreateFeedAdviceFromReferenceComponent implements OnInit, OnDestroy {
  private readonly store = inject<Store<RootState>>(Store);
  private readonly locale = inject(LocaleService);

  /* SELECTORS & DATA */
  referenceSchemes$: Observable<ReferenceScheme[]> = this.store.select(getReferenceSchemes);

  /* INDICATORS */
  isAdvisor = false;

  /* SUBSCRIPTIONS */
  subAuthorization: Subscription;

  ltr$ = this.locale.ltr$;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    this.subAuthorization = this.store
      .pipe(select(AuthorizationSelectors.hasAtLeastAdvisorRole))
      .subscribe((hasAtLeastAdvisorRole) => {
        this.isAdvisor = hasAtLeastAdvisorRole;
      });
  }
  ngOnDestroy(): void {
    if (this.subAuthorization) {
      this.subAuthorization.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.store.dispatch(feedAdviceActions.loadReferenceSchemesByCountryRequest());
    this.store.dispatch(feedAdviceActions.setBaseFeedAdviceRequest({ feedAdvice: null }));
  }

  fromScratchCreate() {
    if (this.isAdvisor) {
      this.store.dispatch(feedAdviceActions.createAdviceNavigation());
    }
  }

  createFeedAdviceFromReference(referenceScheme: ReferenceScheme) {
    if (this.isAdvisor) {
      const base = referenceScheme as FeedAdvice;
      this.store.dispatch(feedAdviceActions.setBaseFeedAdviceRequest({ feedAdvice: base }));
      this.store.dispatch(feedAdviceActions.createAdviceNavigation());
    }
  }
}
